import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {LeadStatusNotificationDataApiDto, NotificationBaseApiDto} from "../../../api/model/rest";
import {getUser} from "../../../store/view/user";
import LeadStatusNotificationData from "./LeadStatusNotificationData";
import {getLeadStatus} from "../../../store/view/leadStatus";

/**
 * Comment notification class.
 */
export default class LeadStatusNotification extends NotificationBase {
	/**
	 * @param {string} id Notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read Flag if comment is marked as read.
	 * @param {"LEAD_STATUS"} type Comment type, in this case always 'LEAD_STATUS'.
	 * @param {LeadStatusNotificationData} data Lead history notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: LeadStatusNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): LeadStatusNotification {
		return new LeadStatusNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			LeadStatusNotificationData.fromJson(json.data as LeadStatusNotificationDataApiDto));
	}

	/**
	 * Display user Full name.
	 * @returns {string}
	 */
	displayCreatorName() {
		return getUser(this.data.creator.id).map(u => u.getDisplayName()).getOrElse(this.data.creator.id);
	}

	/**
	 * Get previous status label.
	 * @returns {string}
	 */
	getPreviousStatusLabel(): string {
		return getLeadStatus(this.data.previousStatusId).map(ps => ps.getStatusLabel()).getOrElse("UNKNOWN");
	}

	/**
	 * Get current status label.
	 * @returns {string}
	 */
	getCurrentStatusLabel(): string {
		return getLeadStatus(this.data.currentStatusId).map(cs => cs.getStatusLabel()).getOrElse("UNKNOWN");
	}

	/**
	 * Get notification icon depending on current job status.
	 * @returns {string}
	 */
	getNotificationIcon() {
		return getLeadStatus(this.data.currentStatusId).map(cs => cs.getStatusIcon()).orNull;
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new LeadStatusNotification(id, dateTime, read, type, data);
	}
}